BOLD = BOLD || {};
BOLD.options = BOLD.options || {};
BOLD.options.templates = BOLD.options.templates || {}

// here is where you assign a new value to the template you'd like to change
let _boldMultiTemplate = `<div data-asas class="bold_option bold_option_{{ optionType }}">
{{#optionTitle}}
    <span class="bold_option_title">{{{ optionTitle }}}</span>
{{/optionTitle}}

{{#toolTip}}<span class="bold_tooltip"><small>{{{ toolTip }}}</small></span>{{/toolTip}}

<span class="bold_option_element">
    {{#optionElement}}
        <span class="bold_option_value {{#optionValueNoStock}}bold_option_out_of_stock{{/optionValueNoStock}}">
            {{#optionValueElement}}
                <span class="bold_option_value_element">{{{ optionValueElement }}}</span>
            {{/optionValueElement}}
            <label>
                {{#optionValueTitle}}
                    <span class="bold_option_value_title">{{{ optionValueTitle }}}</span>
                {{/optionValueTitle}}

                {{#optionValuePrice}}
                    <span class="bold_option_value_price">{{{ optionValuePrice }}}</span>
                {{/optionValuePrice}}
            </label>
            
            {{#optionValueQuantity}}
                <span class="bold_option_value_quantity">{{{ optionValueQuantity }}}</span>
            {{/optionValueQuantity}}
            
            {{#optionValueNoStock}}
                <span class="bold_out_of_stock_message">
                    <small>{{ outOfStockMessage }}</small>
                </span>
            {{/optionValueNoStock}}
        </span>
    {{/optionElement}}
</span>

{{#helpText}}<span class="bold_help_text"><small>{{{ helpText }}}</small></span>{{/helpText}}
</div>`;

BOLD.options.templates.multi = _boldMultiTemplate;

